import React, { useState } from "react";
import Modal from "../Modal";
import ProductAuth from "../ProductAuth"; // ✅ Product Authentication Component import
export default function Footer(){
  const [showModal, setShowModal] = useState(false);
    return(
        <>
        
<footer className="footer">
  <div className="primary-footer">
    <div className="container">
      <div className="row align-items-center footer-top">
        <div className="col-lg-6">
          <h2 className="text-white mb-0"> Need help on Emergency? Book Your Appointment Today. </h2>
        </div>
        <div className="col-lg-6 text-lg-end mt-4 mt-lg-0">
          <a href="contact" className="themeht-btn primary-btn">Contact US</a>
           <button
                  className="themeht-btn white-btn ms-3"
                  onClick={() => setShowModal(true)}
                >
                  Product Authentication
                </button> 
        
        </div>
      </div>
      <div className="footer-btm">
        <div className="row">
          <div className="col-lg-4 pe-lg-8">
            <a className="navbar-brand logo footer-logo mb-4 d-inline-block" href="index.html">
              <img className="img-fluid" src="images/logo-white.svg" alt=""/>
            </a>
            <ul className="media-icon list-unstyled">
              {/* <li>
                <i className="flaticon flaticon-location-1"></i>
                <p className="mb-0">Industrial Area, Mohali </p>
              </li> */}
              <li>
                <i className="flaticon flaticon-envelope"></i>
                <a href="mailto:themeht23@gmail.com">info@OlympiansLabs.com</a>
              </li>
              {/* <li>
                <i className="flaticon flaticon-phone"></i>
                <a href="tel:+912345678900">+91-12345-66785</a>
              </li> */}
            </ul>            
          </div>          
          <div className="col-lg-8 mt-5 mt-lg-0">
            <div className="row">              
              <div className="col-md-3 footer-menu">
                <h5>Quick Links</h5>
                <ul className="list-unstyled w-100">
                  <li>
                    <a href="aboutus">About Us</a>
                  </li>
                  <li>
                    <a href="contact">Contact Us</a>
                  </li>
                
                  <li>
                    <a href="productauth">Verify Product</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3 mt-5 mt-md-0 footer-menu">
                <h5>Our Categories</h5>
                <ul className="list-unstyled">
                  <li>
                    <a href="tabletssection">TABLETS</a>
                  </li>
                  <li>
                    <a href="injectableSection">INJECTIBLES</a>
                  </li>
                  <li>
                    <a href="peptidesSection">PEPTIDES</a>
                  </li>
                 
                </ul>
              </div>
              <div className="col-md-6 mt-5 mt-md-0 ps-lg-8 footer-subscribe">
            <h5>Newsletter</h5>
            <p>Build responsive, mobile-first projects on the web with the world’s most popular front-end component library.</p>
            <form id="mc-form" className="mc-form subscribe-form">
              <input type="email" value="" name="EMAIL" className="email" id="mc-email" placeholder="Email Address" required=""/>
              <button type="submit" value="Sign up">
                <i className="bi bi-send-fill"></i>
              </button>
            </form>
          </div>
            </div>
          </div>
        </div>
        <div className="secondary-footer">
          <div className="row">
            <div className="col-lg-7 copyright">Copyright 2025 Olympians Laboratories. <u>
                
              </u> | All Rights Reserved </div>
                </div>
        </div>
      </div>
    </div>
  </div>
<div className="animated-icon-shape">
  <img className="img-fluid small-circle-animation" src="assets/images/small-icon/01.png" alt=""/>
  <img className="img-fluid small-circle-animation" src="assets/images/small-icon/05.png" alt=""/>
  <img className="img-fluid small-circle-animation" src="assets/images/small-icon/06.png" alt=""/>
  <img className="img-fluid small-circle-animation" src="assets/images/small-icon/04.png" alt=""/>
</div>
</footer>
        {/* ✅ MODAL SHOW */}
      {showModal && (
        <Modal show={showModal} onClose={() => setShowModal(false)}>
          <ProductAuth /> {/* Product Authentication component inside modal */}
        </Modal>
      )}


        </>
    )
}